var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('LandingSlide'),_c('SearchBar'),_c('ProductSalesSlide',{attrs:{"isCamping":false}}),_c('LandingTypes'),_c('LandingValues'),_c('LandingBannerMiddle'),_c('LandingAbout'),_c('Clubs',{attrs:{"isCamping":false}}),_c('LandingNews')],1)}
var staticRenderFns = []

export { render, staticRenderFns }